
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert('كلمات المرور غير متطابقة');
      return;
    }
    
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('/dashboard');
    }, 2000);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
      {/* Header */}
      <div className="pt-16 pb-6 text-center">
        <div className="w-20 h-20 mx-auto mb-4 bg-blue-600 rounded-3xl flex items-center justify-center animate-bounce-slow">
          <i className="ri-calculator-line text-3xl text-white"></i>
        </div>
        <h1 
          className="text-3xl font-bold text-blue-900 mb-2"
          style={{fontFamily: "Pacifico, serif"}}
        >
          الحاسبة المالية
        </h1>
        <p className="text-blue-600">إنشاء حساب جديد</p>
      </div>

      {/* Form Container */}
      <div className="flex-1 bg-white rounded-t-3xl px-6 pt-6 pb-6 animate-slide-up">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <button
              type="button"
              onClick={() => navigate('/auth/login')}
              className="flex items-center text-blue-600 mb-4"
            >
              <i className="ri-arrow-right-line ml-2"></i>
              العودة لتسجيل الدخول
            </button>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">إنشاء حساب</h2>
            <p className="text-gray-500">املأ البيانات التالية لإنشاء حسابك</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium mb-2">الاسم الكامل</label>
              <input
                type="text"
                value={formData.fullName}
                onChange={(e) => handleInputChange('fullName', e.target.value)}
                placeholder="أدخل اسمك الكامل"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">رقم الجوال</label>
              <div className="relative">
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                  <span className="text-gray-400">+966</span>
                </div>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  placeholder="5xxxxxxxx"
                  className="w-full pr-16 pl-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  maxLength={9}
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">البريد الإلكتروني (اختياري)</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                placeholder="example@email.com"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">كلمة المرور</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={(e) => handleInputChange('password', e.target.value)}
                  placeholder="أدخل كلمة مرور قوية"
                  className="w-full px-4 py-3 pl-12 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                >
                  <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                </button>
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-2">تأكيد كلمة المرور</label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => handleInputChange('confirmPassword', e.target.value)}
                placeholder="أعد إدخال كلمة المرور"
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={!formData.fullName || !formData.phone || !formData.password || !formData.confirmPassword || isLoading}
            className="w-full bg-blue-600 text-white py-4 rounded-xl font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-200 hover:scale-105 active:scale-95 mt-6"
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2 space-x-reverse">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>جاري إنشاء الحساب...</span>
              </div>
            ) : (
              'إنشاء الحساب'
            )}
          </button>

          <div className="text-center text-sm text-gray-500 mt-4">
            بإنشاء الحساب، أنت توافق على 
            <span className="text-blue-600"> الشروط والأحكام</span>
          </div>
        </form>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-slide-up {
          animation: slide-up 0.5s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }
      `}</style>
    </div>
  );
}
